import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  UntypedFormBuilder,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { Tasas } from '@p-p-portafolio/interfaces/tasas';
import { UserService } from '@pages/user/services/user.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { Observable, of } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-tasas-form',
  templateUrl: './tasas-form.component.html',
  styleUrls: ['./tasas-form.component.css'],
  providers: [MessageService]
})
export class TasasFormComponent implements OnInit {
  private _user: string = this._userServices.userCurrent;
  public loading: boolean = false;

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<TasasFormComponent>,
    private _tasasServices: TasasService,
    private _userServices: UserService,
    private messageService: MessageService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public model: Tasas
  ) {
    _dialogRef.disableClose = true;
    if (this.model !== null) {
      const fechaMoment = moment(model.fechaInicia, 'DD/MM/YY');
      const setModel = {
        clave: model.clave,
        fechaInicia: fechaMoment.isValid() ? fechaMoment.format('YYYY-MM-DD') : '',
        descripcion: model.descripcion,
        valor: model.valor,
        formula: model.formula,
        simulatorValor: '',
        user: this._user,
      };
      this.form.setValue(setModel);
    }
  }

  form = this._fb.group({
    clave: [
      '',
      {
        validators: [Validators.required],
        asyncValidators: [this.singleClave()],
        updateOn: 'blur',
      },
    ],
    fechaInicia: ['', Validators.required],
    descripcion: ['', Validators.required],
    valor: ['', Validators.required],
    formula: [''],
    simulatorValor: [''],
    user: this._user,
  });

  ngOnInit() {}

  close() {
    this._dialogRef.close();
  }

  create(model: Tasas) {
    if (this.form.valid) {
      this.loading = true;
      const fecha = moment(model.fechaInicia).format('MM/DD/YY');
      const formattedModel = {
        ...model,
        fechaInicia: fecha
      };
      
      this._tasasServices.create(formattedModel).subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.message) {
            this._dialogRef.close(true);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res.message || 'No se pudo agregar la tasa'
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocurrió un error al agregar la tasa'
          });
        }
      });
    }
  }

  update(model: Tasas) {
    if (this.form.valid) {
      this.loading = true;
      const fecha = moment(model.fechaInicia).format('MM/DD/YY');
      const formattedModel = {
        ...model,
        fechaInicia: fecha
      };
      
      this._tasasServices.update(formattedModel).subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.message) {
            this._dialogRef.close(true);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res.message || 'No se pudo actualizar la tasa'
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocurrió un error al actualizar la tasa'
          });
        }
      });
    }
  }

  simulator() {
    this._tasasServices.simulator(this.model.clave).subscribe((res) => {
      this.form.patchValue({ simulatorValor: res.data[0].valor });
    });
  }

  singleClave(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.model) return of(true);
      else {
        return this._tasasServices.readOne(control.value).pipe(
          map((res) => {
            if (res.exito === 1) return { singleClave: true };
            return null;
          })
        );
      }
    };
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'tasas',
        sClave: this.form.get('clave')?.value,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }
}
